"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.individualDetailStyles = void 0;
const lit_1 = require("lit");
exports.individualDetailStyles = (0, lit_1.css) `
    .card-subtitle {
        font-family: var(--font-family, Roboto);
        font-size: var(--forge-typography-overline-font-size, 12px);
        font-style: normal;
        font-weight: 500;
        line-height: var(--forge-typography-overline-line-height, 32px); /* 266.667% */
        text-transform: uppercase;
        color: #000000;
    }
    .detail-content-review-container {
        display: inline-grid;
        grid-template-columns: repeat(7, 1fr);
        grid-column-gap: 20%;
        margin-bottom: 10px;
        white-space: nowrap;
    }
    .detail-content-edit-container {
        display: inline-grid;
        grid-template-columns: repeat(5, 1fr);
        grid-column-gap: 10px;
        width: 100%;
    }
    .detail-content-edit-address-container {
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin-bottom: 10px;
    }
    .detail-content-edit-address-field {
        flex: 1;
    }
`;
